let Validate = function () {

    let itemRegExp = /^([AC-WY]{1}|[ABC-HJ-LNP-WXY]{2})-([A-Z0-9]{3,7})-[A-Z0-9]{1,21}(($|:[0-9.]{1,4}$)|-[A-Z0-9]{4,7})($|:[0-9.]{1,4}$)/;
    let setRegExp = /^([AC-WY]{1}|[ABC-HJ-LNP-WXY]{2})-[0-9]{4}-[0-9]{1,3}($|:[0-9]{1,2}$)/;
    let warehouseRegExp = /^L-([0-9]{4,})$/

    this.isItemnumber = function (itemnumber) {
        if (typeof itemnumber === 'string') {
            return (itemnumber.match(itemRegExp) !== null);
        } else {
            return false;
        }
    };

    this.isSet = function (setId) {
        if (typeof setId === 'string') {
            return (setId.match(setRegExp) !== null);
        } else {
            return false;
        }
    }

    this.isWarehouse = function (warehouseId) {
        if (typeof warehouseId === 'string') {
            return (warehouseId.match(warehouseRegExp) !== null);
        } else {
            return false;
        }
    }
};

export default new Validate();